import * as types from './action-types';
import { filter } from 'lodash';

const UIState = () => ({
  selectedMenu: 'simple',
  visibleMenus: ['simple', 'import'],
  selectedCell: { ascendancy: 1, generation: 0, index: 0 },
  colorMode: 'individual',
  generationsLocked: false,
  interfaceMode: window.location.pathname.substr(1),
});

export function uiReducer(state = UIState(), {payload, type}) {
  switch (type) {

    case types.SET_SELECTED_MENU:
      return Object.assign({}, state, {
        selectedMenu: payload,
      });

    case types.SET_SELECTED_CELL:
      return Object.assign({}, state, {
        selectedCell: payload,
      })

    case types.SET_VISIBLE_MENUS:
      return Object.assign({}, state, {
        visibleMenus: payload,
      })
    
    case types.SET_COLOR_MODE:
      return Object.assign({}, state, {
        colorMode: payload,
      })

    case types.SET_GENERATIONS_LOCKED:
      return Object.assign({}, state, {
        generationsLocked: payload,
      })

    default: 
      return state;

  }
}


// WEBPACK FOOTER //
// ./src/core/ui/reducer.js